import React from 'react';
import './styles/style.css';

const TerceryButton = ({
  icon,
  text,
  onClick,
  disabled = false,
  type = 'button',
  size = 'M',
  className = '',
  ...props
}) => {
  const sizeClass = size === 'S' ? 'terceryButton--sm' : size === 'L' ? 'terceryButton--lg' : '';

  return (
    <button
      type={type}
      className={`terceryButton ${sizeClass} ${disabled ? 'disabled' : ''} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {icon && <div className="terceryButton-icon notranslate" translate="no">{icon}</div>}
      <div className="terceryButton-text">{text}</div>
    </button>
  );
};

export default TerceryButton;